import { Component, Input } from '@angular/core';
import { SearchResult } from '../../api/models/search-result';
import { SearchUrlParameters } from '../../shared/model/search-url-parameters';
import { SearchEventPublisher } from '../../shared/service/search-event-publisher.service';
import { SearchEventTypeEnum } from '../../shared/model/search-event-type-enum';

@Component({
  selector: 'app-search-no-result',
  templateUrl: './search-no-result.component.html',
  styleUrls: ['./search-no-result.component.scss', './search-no-result.aem.scss'],
})
export class SearchNoResultComponent {
  @Input()
  searchResult!: SearchResult;

  @Input()
  searchParams!: SearchUrlParameters;

  constructor(private searchEventPublisher: SearchEventPublisher) {}

  triggerSearch(params: SearchUrlParameters) {
    this.searchEventPublisher.publishEvent(SearchEventTypeEnum.SEARCH_FROM_URL, params);
  }

  contactUs() {
    window.location.href = 'https://www.ni.com/contact-us';
  }
}
